import * as angular from "angular";
import {IController} from "angular";

export class DemandAccountViewSettingsPanelTemplateComponent implements IController {

  settings: any;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: any;

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: false,
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey].enabled = isEnabled;
  }

  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }


  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountViewSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./demand-account-view-settings-panel-template.html').default,
    controller: DemandAccountViewSettingsPanelTemplateComponent
  });
